import {
  VStack,
  type VStackProps,
  Heading,
  type HeadingProps,
  Text,
  type TextProps,
  HStack,
  type HStackProps,
} from '@frontend/legacy-components';

// A small set of components for displaying information displays in the viewer.

export const DisplayWrapper = ({ children, ...props }: VStackProps) => (
  <VStack spacing={0} minWidth="200px" align="end" {...props}>
    {children}
  </VStack>
);

export const DisplayTitle = ({ children, ...props }: HeadingProps) => (
  <Heading color="inherit" size="md" {...props}>
    {children}
  </Heading>
);

export const DisplayEntry = ({ children, ...props }: TextProps) => (
  <Text color="inherit" {...props}>
    {children}
  </Text>
);

export const DisplayEntryWrapper = ({ children, ...props }: HStackProps) => (
  <HStack spacing={0.5} {...props}>
    {children}
  </HStack>
);
